import { dew as _accountsDew } from "../utils/accounts.js";
import { dew as _uidDew } from "../utils/uid.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createClient = void 0;
  const accounts_js_1 = _accountsDew();
  const uid_js_1 = _uidDew();
  function createClient(parameters) {
    const {
      batch,
      cacheTime = parameters.pollingInterval ?? 4000,
      key = "base",
      name = "Base Client",
      pollingInterval = 4000,
      type = "base"
    } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, accounts_js_1.parseAccount)(parameters.account) : undefined;
    const {
      config,
      request,
      value
    } = parameters.transport({
      chain,
      pollingInterval
    });
    const transport = {
      ...config,
      ...value
    };
    const client = {
      account,
      batch,
      cacheTime,
      chain,
      key,
      name,
      pollingInterval,
      request,
      transport,
      type,
      uid: (0, uid_js_1.uid)()
    };
    function extend(base) {
      return extendFn => {
        const extended = extendFn(base);
        for (const key in client) delete extended[key];
        const combined = {
          ...base,
          ...extended
        };
        return Object.assign(combined, {
          extend: extend(combined)
        });
      };
    }
    return Object.assign(client, {
      extend: extend(client)
    });
  }
  exports.createClient = createClient;
  //# sourceMappingURL=createClient.js.map
  return exports;
}